import { ShareIcon } from '@synoptic/ui-kit/icons/react/share.js';
import { PostTagButton } from '@synoptic/ui-kit/post-tag-button/post-tag-button.js';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import { paths } from '@/routes-utils/paths.ts';
import { copyUrlToClipboard } from '@/utils/copy-url-to-clipboard.ts';

export const PostCardShareActionsMenu = ({
  post,
}: {
  post: { id: string };
}) => {
  const toast = useToast();

  return (
    <PostTagButton
      startIcon={<ShareIcon />}
      onClick={(e) => {
        e.stopPropagation();
        copyUrlToClipboard(paths.makePost(post.id));
        toast.info({ title: 'Link copied to clipboard' });
      }}
    >
      Share
    </PostTagButton>
  );
};
